<script setup>
import { ref, watch } from 'vue'

import { COLORS_LIST } from '@/tiptap/constants/define'
import { getIcon } from '@/tiptap/constants/icons'

// JS props with defaults directly on each prop (no withDefaults)
const props = defineProps({
  modelValue: { type: String, default: '' },
  nudgeLeft: { type: [String, Number], default: 0 },
  nudgeTop: { type: [String, Number], default: 0 },
  more: { type: Boolean, default: true },
  mode: { type: String, default: 'color' },
})

const emit = defineEmits(['update:modelValue', 'change'])

const inutValue = ref('')
const menu = ref(false)
// const picker = ref(false)

watch(menu, () => {
  inutValue.value = props.modelValue
})

function setColor(color) {
  emit('update:modelValue', color)
  emit('change', color)

  inutValue.value = color
  menu.value = false
}
</script>

<template>
  <VMenu
    v-model="menu"
    :nudge-left="nudgeLeft || 255"
    :nudge-top="nudgeTop || 42"
    :close-on-content-click="false"
    transition="scale-transition"
    :origin="!nudgeLeft ? 'top right' : 'top left'"
    activator="parent"
  >
    <VList>
      <VSheet class="d-flex flex-wrap justify-between ma-1" fluid :max-width="230">
        <VBtn v-for="color in COLORS_LIST" :key="color" flat icon density="compact" @click="setColor(color)">
          <VIcon :icon="getIcon('circle')" :color="color" />
        </VBtn>

        <div class="hex-row">
          <VTextField
            v-model="inutValue"
            class="hex-input"
            :append-inner-icon="getIcon('check')"
            density="compact"
            label="HEX"
            variant="outlined"
            flat
            hide-details
            single-line
            clearable
            @click:append-inner="setColor(inutValue)"
          >
            <template v-if="inutValue" #prepend-inner>
              <VIcon class="opacity-100" :icon="getIcon('circle')" :color="inutValue" />
            </template>
          </VTextField>

          <VTooltip location="top" :open-delay="0" :close-delay="0">
            <template #activator="{ props: tipProps }">
              <VBtn
                v-bind="tipProps"
                flat
                icon
                density="comfortable"
                class="hex-eraser"
                @click="setColor('')"
              >
                <VIcon :icon="getIcon('eraser')" />
              </VBtn>
            </template>
            <span>{{ props.mode === 'highlight' ? 'Remove highlight' : 'Remove color' }}</span>
          </VTooltip>
        </div>
      </VSheet>


      <!--
      <template>
        <VBtn v-if="!picker" block text @click="picker = true"> show more </VBtn>
        <VBtn v-else block text @click="picker = false"> show less </VBtn>

        <v-expand-transition>
          <div v-if="picker" class="text-center">
            <v-divider />
            <v-color-picker
              :model-value="modelValue"
              hide-mode-switch
              mode="hexa"
              :width="254"
              @update:color="onInput"
            />
          </div>
        </v-expand-transition>
      </template>
      -->
    </VList>
  </VMenu>
</template>

<style scoped>
.hex-row {
  display: flex;
  align-items: center;
  width: 100%;            /* row spans full dropdown width */
  gap: 6px;
  padding: 6px 0 0;       /* match original spacing */
}

.hex-input {
  flex: 1 1 auto;         /* grow to fill remaining space */
  min-width: 0;           /* avoid overflow */
}

.hex-eraser {
  margin-left: auto;      /* push to the far right */
  flex: 0 0 auto;
}

.hex-eraser :deep(.v-icon) {
  font-size: 20px;
  opacity: 0.9;
}
</style>